/**
 * A function to create a log object for the 'wixStudioTpMainAction' event (evid: 901)
 *
 * Event description: Wix Studio TP - Main Action
 *
 * @param {wixStudioTpMainActionParams} params - The parameters for this event
 * @property {string} action - edit, view
 * @property {string} browse_type - browse_type
 * @property {string} browse_value - browse_value
 * @property {string} button_version - button_version
 * @property {string} origin - the src from which the user was redirected to the current page
 * @property {string} slug_id - slug_id
 * @property {string} tab_name - templates, wireframes
 * @property {string} template_id - template_id
 * @property {number} template_index - template_index
 * @property {string} title - template title
 * @return {LogObject<wixStudioTpMainActionParams>} LogObject<wixStudioTpMainActionParams>
 */
export function wixStudioTpMainAction(params) {
    return { evid: 901, src: 2, endpoint: 'generic', params: params };
}
/**
 * A function to create a log object for the 'submitAnswer2QuestionsPage' event (evid: 802)
 *
 * @param {submitAnswer2QuestionsPageParams} params - The parameters for this event
 * @property {string} answer_1 - answer on top question
 * @property {string} answer_2 - answer of second question
 * @property {string} flow - flow
 * @property {string} platform - wix or edix
 * @property {string} question_1 - question on top
 * @property {string} question_2 - second question
 * @property {string} screen_name - screen_name
 * @property {string} text - text the user wrote in case he choose other
 * @return {LogObject<submitAnswer2QuestionsPageParams>} LogObject<submitAnswer2QuestionsPageParams>
 */
export function submitAnswer2QuestionsPage(params) {
    return { evid: 802, src: 2, endpoint: 'generic', params: params };
}
/**
 * A function to create a log object for the 'newEvent' event (evid: 805)
 *
 * Event description: any screen view
 *
 * @param {newEventParams} params - The parameters for this event
 * @property {string} flow - flow
 * @property {string} platform - wix vs edix
 * @property {string} ref - entry point
 * @property {string} screen_name - screen_name
 * @property {string} screen_resolution - screen_resolution
 * @property {string} screen_version - screen version
 * @return {LogObject<newEventParams>} LogObject<newEventParams>
 */
export function newEvent(params) {
    return { evid: 805, src: 2, endpoint: 'generic', params: params };
}
/**
 * A function to create a log object for the 'typeIn' event (evid: 806)
 *
 * Event description: User types an answer
 *
 * @param {typeInParams} params - The parameters for this event
 * @property {string} flow
 * @property {string} platform - wix or edix
 * @property {number} returnedResults - numbers of results
 * @property {string} screen_name - screen_name
 * @property {string} screen_version - screen version
 * @property {string} text - type in text
 * @return {LogObject<typeInParams>} LogObject<typeInParams>
 */
export function typeIn(params) {
    return { evid: 806, src: 2, endpoint: 'generic', params: params };
}
/**
 * A function to create a log object for the 'wixStudioTpHover' event (evid: 903)
 *
 * Event description: Wix Studio TP - When a user has a template above the fold on the Studio Templates Page
 *
 * @param {wixStudioTpHoverParams} params - The parameters for this event
 * @property {string} browse_type - browse_type
 * @property {string} browse_value - browse_value
 * @property {string} origin - the src from which the user was redirected to the current page
 * @property {string} slug_id - slug_id
 * @property {string} tab_name - templates, wireframes
 * @property {string} template_id - template_id
 * @property {number} template_index - template_index
 * @property {string} title - template title
 * @property {number} window_height - Initial height of client window
 * @property {number} window_width - Initial width of client window
 * @return {LogObject<wixStudioTpHoverParams>} LogObject<wixStudioTpHoverParams>
 */
export function wixStudioTpHover(params) {
    return { evid: 903, src: 2, endpoint: 'generic', params: params };
}
/**
 * A function to create a log object for the 'wixStudioTpPageView' event (evid: 900)
 *
 * Event description: Wix Studio TP - Page View
 *
 * @param {wixStudioTpPageViewParams} params - The parameters for this event
 * @property {string} browse_type - browse_type
 * @property {string} browse_value - browse_value
 * @property {string} origin - the src from which the user was redirected to the current page
 * @property {string} tab_name - templates, wireframes
 * @return {LogObject<wixStudioTpPageViewParams>} LogObject<wixStudioTpPageViewParams>
 */
export function wixStudioTpPageView(params) {
    return { evid: 900, src: 2, endpoint: 'generic', params: params };
}
/**
 * A function to create a log object for the 'notificationShownOnTemplatesPage' event (evid: 807)
 *
 * Event description: notification on tamplate page
 *
 * @param {notificationShownOnTemplatesPageParams} params - The parameters for this event
 * @property {string} name - name of banner
 * @property {string} tab_name - templates, wireframes, all
 * @property {string} text - text on banner
 * @property {string} workspace - yes/no
 * @return {LogObject<notificationShownOnTemplatesPageParams>} LogObject<notificationShownOnTemplatesPageParams>
 */
export function notificationShownOnTemplatesPage(params) {
    return { evid: 807, src: 2, endpoint: 'generic', params: params };
}
/**
 * A function to create a log object for the 'clickOnNotificationOnTemplatesPage' event (evid: 808)
 *
 * Event description: Click on Notification on Templates page
 *
 * @param {clickOnNotificationOnTemplatesPageParams} params - The parameters for this event
 * @property {string} cta - text on cta
 * @property {string} name - name of banner
 * @property {string} tab_name - templates, wireframes, all
 * @property {string} text - text on banner
 * @property {string} workspace - yes/no
 * @return {LogObject<clickOnNotificationOnTemplatesPageParams>} LogObject<clickOnNotificationOnTemplatesPageParams>
 */
export function clickOnNotificationOnTemplatesPage(params) {
    return { evid: 808, src: 2, endpoint: 'generic', params: params };
}
/**
 * A function to create a log object for the 'templatesAction' event (evid: 804)
 *
 * Event description: Action in the templates: click, view, hover.
 *
 * @param {templatesActionParams} params - The parameters for this event
 * @property {string} action - hover, edit, view, impression (above the fold)
 * @property {GUID} esi - expressions page esi (original_esi in editorx events)
 * @property {string} flow - flow
 * @property {number} hover_ms - hover time in ms
 * @property {string} origin - the page from which the user was redirected to the current page
 * @property {string} platform - wix or edix
 * @property {number} rank - The template's order. Begins with 1. rank = 0 stands for 'start creating' which leads to a blank template
 * @property {number} screen_height - screen height
 * @property {string} screen_name - screen_name
 * @property {string} screen_version - screen version
 * @property {number} screen_width - screen width
 * @property {string} tab_name - templates, wireframes, all
 * @property {GUID} template_id - template guid
 * @return {LogObject<templatesActionParams>} LogObject<templatesActionParams>
 */
export function templatesAction(params) {
    return { evid: 804, src: 2, endpoint: 'generic', params: params };
}
/**
 * A function to create a log object for the 'generalAction' event (evid: 803)
 *
 * Event description: Extra actions done by the user. For example: go to library, open video, etc.
 *
 * @param {generalActionParams} params - The parameters for this event
 * @property {string} action - action
 * @property {string} flow - flow
 * @property {string} platform - wix or editorx
 * @property {string} screen_name - screen_name
 * @property {string} screen_version - screen version
 * @property {string} tab_name - the type of mode the user is at when doing the action {all, wireframes, templets}
 * @return {LogObject<generalActionParams>} LogObject<generalActionParams>
 */
export function generalAction(params) {
    return { evid: 803, src: 2, endpoint: 'generic', params: params };
}
/**
 * A function to create a log object for the 'wixStudioTpGeneralAction' event (evid: 902)
 *
 * Event description: Wix Studio TP - General Action
 *
 * @param {wixStudioTpGeneralActionParams} params - The parameters for this event
 * @property {string} action - General Action
 * @property {string} action_value - action_value
 * @property {string} browse_type - browse_type
 * @property {string} browse_value - browse_value
 * @property {boolean} is_header - is_header
 * @property {string} origin - the src from which the user was redirected to the current page
 * @property {string} tab_name - templates, wireframes
 * @return {LogObject<wixStudioTpGeneralActionParams>} LogObject<wixStudioTpGeneralActionParams>
 */
export function wixStudioTpGeneralAction(params) {
    return { evid: 902, src: 2, endpoint: 'generic', params: params };
}
/**
 * A function to create a log object for the 'closeNotificationOnTemplatesPage' event (evid: 809)
 *
 * Event description: Close Notification on Templates page
 *
 * @param {closeNotificationOnTemplatesPageParams} params - The parameters for this event
 * @property {string} name - name of banner
 * @property {string} tab_name - templates, wireframes, all
 * @property {string} text - text on banner
 * @property {string} workspace - yes/no
 * @return {LogObject<closeNotificationOnTemplatesPageParams>} LogObject<closeNotificationOnTemplatesPageParams>
 */
export function closeNotificationOnTemplatesPage(params) {
    return { evid: 809, src: 2, endpoint: 'generic', params: params };
}
/**
 * A function to create a log object for the 'selectAnswer' event (evid: 801)
 *
 * Event description: Users selects an answer (not necessarily the final answer)
 *
 * @param {selectAnswerParams} params - The parameters for this event
 * @property {string} answer_name - answer name
 * @property {string} flow - flow
 * @property {string} platform - wix vs editorx
 * @property {string} question_name - question_name
 * @property {string} screen_name - screen_name
 * @property {string} screen_version - screen_version
 * @property {boolean} suggested_option
 * @return {LogObject<selectAnswerParams>} LogObject<selectAnswerParams>
 */
export function selectAnswer(params) {
    return { evid: 801, src: 2, endpoint: 'generic', params: params };
}
//# sourceMappingURL=index.js.map